import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router';
import { browserHistory } from 'src/history/history';

import reducer from './reducer';

const middleware = [thunk, createRouterMiddleware(browserHistory)];

export default createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);
